import * as React from "react";
const SvgFiRrPenFancySlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pen-fancy-slash_svg__a)">
      <path
        fill="#062147"
        d="m12.357 17.3-.646 2.056a4.31 4.31 0 0 1-3.112 2.89l-7.37 1.728a.998.998 0 0 1-1.203-1.202l1.728-7.37a4.31 4.31 0 0 1 2.891-3.113l2.056-.646a1 1 0 1 1 .6 1.908l-2.056.646a2.3 2.3 0 0 0-1.543 1.662l-.926 3.952 2.518-2.518a.999.999 0 1 1 1.414 1.414L4.19 21.225l3.953-.927a2.3 2.3 0 0 0 1.661-1.542l.646-2.056a1 1 0 0 1 1.908.6m11.35 4.993a.999.999 0 1 1-1.414 1.414l-22-22A.999.999 0 1 1 1.707.293l8.88 8.88L18.878.878A3.002 3.002 0 0 1 24 3c0 .801-.313 1.555-.879 2.122l-8.293 8.292zM12 10.586 13.414 12l8.293-8.293A1 1 0 0 0 22 3a1 1 0 0 0-1.707-.707z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pen-fancy-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPenFancySlash;
